module.exports = {
	data() {
		return {
		}
	},
	created: function () {
		return true;
	},
	methods: {
		getDns: function(domain, ip) {
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.get("/namesilo/getdns?domain=" + domain + "&ip=" + ip, headers)
			.then(function (response) {
				let errs = []
				if(response.data.log.Additions.length < 2) errs.push("Only " + response.data.log.Additions.length + "Addition") 
				for(let i in response.data.log.Additions) {
					if(response.data.log.Additions[i].message.code != '300')
						errs.push(response.data.log.Additions[i].message.detail) 
				}
				for(let i in response.data.log.Deletions) {
					if(response.data.log.Deletions[i].message.code != '300')
						errs.push(response.data.log.Deletions[i].message.detail) 
				}
				if(errs.length > 0) {
					alert(errs.join("\n"))
				}
				else {
					alert("WELL DONE")
				}
				console.log(response)
			})
			.catch(function (error) {
				alert("There was an error processing your request.")
				 console.log(error)
			})

		},
		setMonitor: function (data) {
			let that = this
			if((data.table == 'HOSTING' && (!data.HO_WP_BASEURL || data.HO_WP_BASEURL == '')) || (data.table == 'SERVER' && (!data.M_WP_URL || data.M_WP_URL == '')) ) {
				alert("No URL available for this domain: ")
				return false
			}
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post("/monitors/set", data, headers)
			.then(function (response) {
				let msg = (data.action == "add") ? "Added" : "Deleted"
				let typefieldname = data.type.toUpperCase()
				typefieldname = (data.M_ID) ? 'M_MONITOR_' + typefieldname : 'HO_MONITOR_' + typefieldname
				let id = response.id;
				that[typefieldname] = id
				if(response.Error) {
					that.$toastr.Add({
						title: "ERROR", // Toast Title
						msg: response.Error,
						position: "toast-top-center",
						type: "error"
					});
				}
				else {
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: msg + " monitor",
						position: "toast-top-center",
						type: "success"
					});
				}
				console.log(response)
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showadder = false;
				 console.log(error)
			})
		},
	}
}